import React from 'react';
import { Link } from 'react-router-dom';
import elementWhite3 from '../../assets/images/element_white_3.webp';
import elementWhite4 from '../../assets/images/element_white_4.webp';
import customerIcon from '../../assets/images/customer-icon.webp';
import { supportMailto } from '../../constants/brand';
import { siteCopy } from '../../content/siteCopy';

const Call = () => {
  const { homeCall } = siteCopy;

  return (
    <section className="cta_section new white_text" id="support_sec">
      <div className="container">
        <div className="cta_box">
          <div className="element">
            <span className="element1">
              <img src={elementWhite3} alt="" aria-hidden="true" />
            </span>
            <span className="element2">
              <img src={elementWhite4} alt="" aria-hidden="true" />
            </span>
          </div>
          <div className="left">
            <div
              className="section_title"
              data-aos="fade-in"
              data-aos-duration={1500}
              data-aos-delay={100}
            >
              <img src={customerIcon} className="customer_icon" alt="" aria-hidden="true" />
              <h3>{homeCall.title}</h3>
              <p>
                {homeCall.intro[0]}
                <br />
                {homeCall.intro[1]}
              </p>
            </div>
          </div>
          <div className="right">
            <div className="btn_block">
              <Link to={homeCall.contactCtaTo} className="btn puprple_btn">
                {homeCall.contactCtaLabel}
              </Link>
              <Link to={supportMailto('Noor support')} className="btn btn_border">
                {homeCall.emailCtaLabel}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Call;
